import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {ModalMessageComponent} from '../utils/modals/modal-message/modal-message.component';
import { SupportTicketsComponent } from '../popup/support-tickets/support-tickets.component';
import { UserSupportTicketComponent } from '../popup/user-support-ticket/user-support-ticket.component';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ModalControlService {

  constructor(private modalService : BsModalService) { }

  showMesssageModal(title:string, body : string, okButtonText?:string, onCloseFunction?: Function){
    const bsModalRef : BsModalRef = this.modalService.show(ModalMessageComponent, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
    this.setModalOptions(bsModalRef, title, body, okButtonText, onCloseFunction, false);
  }

  showFormattedTextMesssageModal(title:string, body : string, okButtonText?:string, onCloseFunction?: Function){
    const bsModalRef : BsModalRef = this.modalService.show(ModalMessageComponent, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
    this.setModalOptions(bsModalRef, title, body, okButtonText, onCloseFunction, true);
  }

  showMultipleMesssagesModal(title:string, bodyList : string[], okButtonText?:string,callbackFunction?:Function){
    const bsModalRef : BsModalRef = this.modalService.show(ModalMessageComponent, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
    bsModalRef.content.title = title;
    bsModalRef.content.bodyList = bodyList;
    bsModalRef.content.callbackFunction = callbackFunction;
    bsModalRef.content.bsModalRefId = bsModalRef.id;

    if(okButtonText){
      bsModalRef.content.buttonText = okButtonText;
    }
  }

  openSupportTickets(ticketId?:number){
    if (!environment.enablePreReleaseTools) {
      return;
    }

    const initialState = {
      selectedTicketId: ticketId
    };
    this.modalService.show(SupportTicketsComponent, { initialState });

  }


  openSupportTicketCreationModal(){
    if (!environment.enablePreReleaseTools) {
      return;
    }

    this.modalService.show(UserSupportTicketComponent, {
        backdrop: 'static'
      });
    }


  private setModalOptions(bsModalRef: BsModalRef<any>, title:string, body : string, okButtonText:string, onCloseFunction: Function, isFormattedText: boolean) {
    bsModalRef.content.title = title;
    bsModalRef.content.body = body;
    bsModalRef.content.bsModalRefId = bsModalRef.id;

    if(okButtonText){
      bsModalRef.content.buttonText = okButtonText;
    }
    if(onCloseFunction){
      bsModalRef.content.onCloseFunction = onCloseFunction;
    }
    if(isFormattedText){
      bsModalRef.content.isFormattedText = isFormattedText;
    }
  }
}
